import { render } from "./WirepasLocationFormModal.vue?vue&type=template&id=a925cab0&scoped=true&ts=true"
import script from "./WirepasLocationFormModal.vue?vue&type=script&lang=ts"
export * from "./WirepasLocationFormModal.vue?vue&type=script&lang=ts"

import "./WirepasLocationFormModal.vue?vue&type=style&index=0&id=a925cab0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a925cab0"]])

export default __exports__